import { Box, CircularProgress, Input, Typography } from '@mui/material';
import { MagnifyingGlass } from 'phosphor-react';
import { useEffect, useState } from 'react';
import NoteBox from '../components/Notes/NoteBox';
import { useAppDispatch } from '../store/hooks';
import { createNotification } from '../store/notifications/notification-slice';
import { UserService } from '../Service/UserService';
import { Note } from '../Utilis/Types/Notes';
import { Loading } from '../components/Loading';

const Notes = () => {
  const [notes, setNotes] = useState<Note[]>([]);
  const [loading, setLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState('');
  const appDispatch = useAppDispatch();
  useEffect(() => {
    const getNotes = async () => {
      setLoading(true);
      try {
        const response = await UserService.getNotes();

        setNotes(response.data);
      } catch (error) {
        appDispatch(
          createNotification({
            message: 'Something went wrong while fetching notes',
            type: 'error',
          })
        );
      } finally {
        setLoading(false);
      }
    };
    getNotes();
  }, []);

  const filteredNotes = notes.filter(note =>
    note?.body?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Loading isLoading={loading}>
        <Input
          placeholder='Search'
          disableUnderline={true}
          value={searchQuery}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '16px',
            borderBottom: '1px solid #DBE0E2',
            backgroundColor: '#ffffff',
          }}
          onChange={e => setSearchQuery(e.target.value)}
          startAdornment={<MagnifyingGlass size={14} />}
        />

        <Box sx={{ padding: '32px 32px 0 32px' }}>
          <Typography
            color={'#202A2D'}
            fontSize={'20px'}
            fontWeight={'600'}
            lineHeight={'24px'}
            sx={{
              marginBottom: '24px',
            }}
          >
            Notes
          </Typography>
          {filteredNotes.map(note => (
            <NoteBox key={note.id} note={note} />
          ))}
        </Box>
      </Loading>
    </Box>
  );
};

export default Notes;
